<div class="card">
  <div class="card-header flex-between">
    <h5>MyLaps Monitoring</h5>
    <div class="flex-start">
      <types-selector></types-selector>
      <input type="text" class="datetimepicker" [ngClass]="{ 'datepicker-disabled': loading }"
        [attr.disabled]="loading ? '' : null" />
    </div>
  </div>
  <div class="card-body">
    <div class="form-group mt-2">
      <label>Select your Event</label>
      <post-race-location-picker [locations]="events" [selected]="selected" (selectedLocation)="selectEvent($event)"
        type="event"></post-race-location-picker>
      <div *ngIf="events.length == 0">
        No Events Found on <b>{{ date }}</b>
      </div>
    </div>
  </div>
  <div class="card-body">
    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="loading">
      <div class="spinner"></div>
    </div>

    <!-- Status Overview -->
    <div class="overview-section flex-start">
      <!-- Existing status indicators -->
      <div class="overview-field flex-1">
        <div class="circle-dotted" [ngClass]="{
            'status-alive': status.heartbeat === 'alive',
            'status-down': status.heartbeat === 'down'
          }"></div>
        <div class="label-text">GH TraCe Heartbeat</div>
      </div>
      <div class="overview-field flex-1">
        <div class="circle-dotted" [ngClass]="{
            'status-alive': status.lap === 'alive',
            'status-no-connection': status.lap === 'NoConnection'
          }"></div>
        <div class="label-text">GR TraCe to Mylaps oncourse</div>
      </div>
      <div class="overview-field flex-1">
        <div class="text-success fw-bold number-status">
          {{ status["completedRaces"] }}
        </div>
        <div class="label-text">Completed Races</div>
      </div>
    </div>

    <!-- Network Status Section -->
    <div class="overview-section" *ngIf="!loadingNetworkStatus && selected">
      <h6>Network Status</h6>
      <div class="network-grid" *ngIf="network_status.length > 0">
        <div *ngFor="let device of network_status" class="status-item">
          <div class="status-icon">
            <i class="fas fa-desktop"></i>
            <span class="status-indicator"
              [ngClass]="{'success': getDeviceStatus(device.status) === 'success', 'failed':  getDeviceStatus(device.status) === 'failed'}"></span>
          </div>
          <div class="status-content">
            <div class="status-header">
              <span class="status-label">{{ device.name }}</span>
              <div class="status-tags">
                <span class="tag job">{{ device.job }}</span>
                <span class="tag service">{{ device.service }}</span>
              </div>
            </div>
            <div class="status-details">
              <span class="status-ip">{{ device.instance }}</span>
              <span class="status-message"
                [ngClass]="{'success':  getDeviceStatus(device.status) === 'success', 'failed':  getDeviceStatus(device.status) === 'failed'}">{{ device.status_message
                }}</span>
            </div>
            <div class="status-timestamp">Last Updated: {{ device.timestamp }}</div>
          </div>
        </div>
      </div>
      <div *ngIf="network_status.length === 0" class="table-placeholder">No network data found.</div>
    </div>
    <div *ngIf="loadingNetworkStatus" class="loading-container flex-center">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
      <p>Loading network status...</p>
    </div>

    <!-- Table Title with Submit Button -->
    <div class="flex-between mb-2">
      <h6 class="section-title">Race List</h6>
      <button class="btn btn-success-soft" *ngIf="hasUnsavedChanges && races.length > 0"
        (click)="submitRaceTimeUpdates()">
        Submit Race Time Updates
      </button>
    </div>

    <!-- Enhanced Race Table -->
    <div *ngIf="!loading && races.length > 0">
      <table class="table table-centered">
        <thead>
          <tr>
            <th>Time</th>
            <th>Race Number</th>
            <th>Distance</th>
            <th>Venue</th>
            <th>Race Status</th>
            <th>Status</th>
            <th>Loops (1-10)</th>
            <th>Pulse</th>
            <th>Reports</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let race of races">
            <td class="time-cell"> <span [innerHTML]="race.RaceTimeHTML || race.RaceTime"></span>
              <i class="fa fa-pencil race-time-icon" *ngIf="isRaceTimeEditable(race)"
                (click)="handleRaceTimeClick(race)"></i>
            </td>
            <td>{{ race.SquentialRaceOrderNumber }}</td>
            <td>{{ race.RaceLength }}m</td>
            <td class="text-center">{{ race?.venue_name }}</td>
            <td>
              <app-horsestatus [data]="race.status"></app-horsestatus>
            </td>
            <td>
              <span class="status-badge" [ngClass]="race.RaceState.toLowerCase()">
                {{ race.RaceState }}
              </span>
            </td>
            <td>
              <div class="flex-center">
                <table class="no-border">
                  <tbody>
                    <tr>
                      <td *ngFor="let loop of race['loopsData']" class="section-loop-status tooltip-container"
                        [ngClass]="{
                          'status-success': loop['status'] == 'green',
                          'status-warning': loop['status'] == 'yellow',
                          'status-failed': loop['status'] == 'red',
                          'status-blue': loop['status'] == 'blue',
                          'status-orange': loop['status'] == 'orange'
                        }">
                        {{ loop["passed"] }}
                        <div class="tooltip-content" *ngIf="
                            loop.passedList.length > 0 ||
                            loop.failedList.length > 0
                          ">
                          <div class="tooltip-section" *ngIf="loop.passedList.length > 0">
                            <strong>Passed ({{ loop.passedList.length }}):</strong>
                            <div>{{ formatAnimalList(loop.passedList) }}</div>
                          </div>
                          <div class="tooltip-section" *ngIf="loop.failedList.length > 0">
                            <strong>Failed ({{ loop.failedList.length }}):</strong>
                            <div>{{ formatAnimalList(loop.failedList) }}</div>
                          </div>
                        </div>
                      </td>
                      <td class="section-loop-status tooltip-container" [ngClass]="{
                          'status-success': getFailedLoops(race).length == 0,
                          'status-failed': getFailedLoops(race).length > 0,
                        }">
                        {{ getTotalLoops(race).length }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
            <td>
              <div class="loop-status" [ngClass]="{
                  'status-success': race['pulseStatus'] === 'green',
                  'status-failed': race['pulseStatus'] === 'red',
                  'status-neutral': race['pulseStatus'] === 'blue'
                }" [attr.title]="getPulseTooltip(race)"></div>
            </td>
            <td>
              <app-reportstatus [data]="race.buttonActions"></app-reportstatus>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- No Data Placeholder -->
    <div class="table-placeholder" *ngIf="!loading && races.length === 0">
      No races found for the selected date.
    </div>
  </div>
</div>

<!-- Race Time Popup styled like venue-details -->
<div *ngIf="showRaceTimePopup" class="popup-screen">
  <div class="popup-container">
    <div class="popup-header">
      Update Race Time
      <button type="button" class="close" (click)="closeRaceTimePopup()">
        &times;
      </button>
    </div>
    <div class="popup-body">
      <div class="flex-start align-items-start">
        <div>
          <label>Current Race Time: </label>
          <div>{{ selectedRace?.RaceTime }}</div>
        </div>
        <div class="arrow">→</div>
        <div>
          <label>New Race Time: </label>
          <div class="flex-start">
            <select class="form-select" [(ngModel)]="newRaceTime.hour">
              <option *ngFor="let hour of hours" [value]="hour">
                {{ hour }}
              </option>
            </select>
            :
            <select class="form-select" [(ngModel)]="newRaceTime.minute">
              <option *ngFor="let minute of minutes" [value]="minute">
                {{ minute }}
              </option>
            </select>
          </div>
          <div class="flex-start">
            <span class="nav-link pointer" (click)="addMinutes(-5)">-5 mins</span>
            <span class="nav-link pointer" (click)="addMinutes(-15)">-15 mins</span>
            <span class="nav-link pointer" (click)="addMinutes(5)">+5 mins</span>
            <span class="nav-link pointer" (click)="addMinutes(15)">+15 mins</span>
            <span class="nav-link pointer" (click)="addMinutes(30)">+30 mins</span>
          </div>
        </div>
      </div>
      <div class="mt-3 flex-end">
        <button class="btn btn-primary-soft" (click)="resetRaceTIme()" *ngIf="selectedRace && selectedRace.timeChanged">
          Reset
        </button>
        <button class="btn btn-success-soft" (click)="updateRaceTime()">
          Update
        </button>
        <button class="btn btn-light" (click)="closeRaceTimePopup()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
